/**
 * `/sso-callback` — where Google sends the browser back (3 Oct 2026).
 *
 * Clerk's `<AuthenticateWithRedirectCallback/>` finishes the OAuth
 * attempt (`Clerk.handleRedirectCallback`), which is what Clerk's
 * custom-flow guide prescribes. It covers both transfer cases on its own:
 *
 *   - a Google account with no Tarii user, started from Sign in →
 *     `signUp.create({ transfer: true })` (a sign-up, so bot protection
 *     runs here — hence the `#clerk-captcha` slot below);
 *   - a Google account that already has a user, started from Sign up →
 *     `signIn.create({ transfer: true })`.
 *
 * Whatever is left over is routed back to OUR pages, never to Clerk's
 * Account Portal: anything a sign-in still needs (an emailed code, a new
 * password) → `/sign-in/continue`; a sign-up still missing a field →
 * `/sign-up/continue`; errors → the start pages, which show them.
 *
 * A straight sign-in with an existing Google user never lands here —
 * Clerk redirects to `redirectUrlComplete` (`/`) directly, and the entry
 * gates take over as they always have.
 */
import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";

import { AuthFrame, CaptchaSlot } from "./AuthFrame";

export function SsoCallbackPage() {
  return (
    <AuthFrame title="Signing you in" lead="Finishing with Google. This takes a moment.">
      <output className="block text-fg-muted text-sm">Please keep this page open.</output>
      <AuthenticateWithRedirectCallback
        signInUrl="/sign-in"
        signUpUrl="/sign-up"
        signInFallbackRedirectUrl="/"
        signUpFallbackRedirectUrl="/"
        firstFactorUrl="/sign-in/continue"
        secondFactorUrl="/sign-in/continue"
        resetPasswordUrl="/sign-in/continue"
        continueSignUpUrl="/sign-up/continue"
        verifyEmailAddressUrl="/sign-up/continue"
      />
      <CaptchaSlot />
    </AuthFrame>
  );
}
